// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import http from './utils/http'
import * as auth from './utils/auth'
import * as api from './utils/api'
import BootstrapVue from 'bootstrap-vue'
import swal from 'sweetalert'
import globalComponents from './global-components'
import globalFilters from './global-filters'
import VueMoment from 'vue-moment'
import moment from 'moment'
import 'moment/locale/nl'

// CSS
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import 'swiper/dist/css/swiper.css'

Vue.config.productionTip = false

Vue.prototype.$http = http
Vue.prototype.$auth = auth
Vue.prototype.$api = api
Vue.prototype.$swal = swal

Vue.use(BootstrapVue)
Vue.use(globalComponents)
Vue.use(globalFilters)
Vue.use(VueMoment, { moment })

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js